import { Component, OnInit, Input } from '@angular/core';
import { SearchOption } from 'types';
import { Enum } from '../model/features-decl';
import { FeaturesImpl } from '../model/features-impl';
import { AppContext } from '../control/context';
import { ValidationService } from '../validation/validation.service';

export class EnumOptionViewModel {
  checked: boolean;
  caption: string;
  id: string;
}

export class SearchFieldViewModel {
  targetPropertyPath: string;
  get valuePath(): string {
    try {
      return this.fieldPrototype.constructor.name === 'MaskedDate' ||
        this.fieldPrototype.constructor.name === 'NullableString' ||
        this.isEnum
        ? '.value'
        : '';
    } catch {
      return '';
    }
  }
  val: any;
  fieldPrototype: any;
  rootPrototype: any;
  i18nName: string;
  searchOption: SearchOption = SearchOption.Partial;
  get isEnum(): boolean {
    return this.fieldPrototype instanceof Enum;
  }

  flex: string;
  searchOptionSelectionVisible: boolean = false;
  enumRadioButtonsMode: boolean = true;
}

@Component({
  selector: 'i-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  providers: [{ provide: ValidationService, useClass: ValidationService }],
})
export class SearchFieldComponent implements OnInit {
  constructor(private _appContext: AppContext) {}

  @Input() viewModel: SearchFieldViewModel;
  @Input() template: any;

  _i18n_name: string;

  // MaskedDate
  searchOptionExact: SearchOption = SearchOption.Exact;
  searchOptionInterval: SearchOption = SearchOption.Interval;
  maskedDate: string | null = '';
  maskedDateBegin: string | null = '';
  maskedDateEnd: string | null = '';

  onMaskedDateSearchOptionChanged() {
    if (this.viewModel.searchOption.equals(SearchOption.Interval)) {
      const x = this.parseMaskedDate(this.maskedDateBegin) || null;
      const y = this.parseMaskedDate(this.maskedDateEnd) || null;
      this.viewModel.val = x || y ? { begin: x, end: y } : null;
    } else if (this.viewModel.searchOption.equals(SearchOption.Exact)) {
      const x = this.parseMaskedDate(this.maskedDate) || null;
      this.viewModel.val = x ? x : null;
    }
  }

  // Enum
  enumOptions: EnumOptionViewModel[] = [];
  onEnumOptionToggle() {
    const vals: any[] = [];
    this.enumOptions
      .filter((opt) => opt.checked)
      .forEach((opt) => {
        vals.push(opt.id);
      });
    this.viewModel.val = vals;
    if (this.viewModel.val.length === 0) {
      this.viewModel.val = null;
    }
  }

  ngOnInit(): void {
    if (this.viewModel.isEnum) {
      this.viewModel.searchOption = SearchOption.SearchByEnum;
      for (const key in this.viewModel.fieldPrototype.constructor) {
        const value = (this.viewModel.fieldPrototype.constructor as any)[key];
        if (value instanceof this.viewModel.fieldPrototype.constructor) {
          this.enumOptions.push({
            checked: false,
            id: value.value,
            caption: Object.getPrototypeOf(value).constructor.unwrap(value),
          });
        }
      }
    }
    this._i18n_name = this._appContext.getI18NString(this.viewModel.i18nName);
  }

  clear(): void {
    this.maskedDate = '';
    this.maskedDateBegin = '';
    this.maskedDateEnd = '';
    this.enumOptions.forEach((x) => (x.checked = false));
    this.viewModel.val = null;
  }

  private parseMaskedDate(val: string | null): string | null {
    return FeaturesImpl.parseMaskedDate(this.viewModel.targetPropertyPath, this.template, val, this._appContext.getLocale());
  }
  private formatMaskedDate(val: string | null, monthFormat: 'letters' | null): string | null {
    return FeaturesImpl.formatMaskedDate(null, val, this._appContext.getLocale(), monthFormat);
  }
  parseMaskedDateLambda = (val: string | null) => this.parseMaskedDate(val);
  formatMaskedDateLambda = (val: string | null, monthFormat: 'letters' | null) => this.formatMaskedDate(val, monthFormat);

  i18n(key: string): string {
    return this._appContext.getI18NString(key);
  }
}
